import React from 'react';
import { Col, Row } from 'antd';
import Auxiliary from '../../util/Auxiliary';
import PendingTransactions from './PendingTransactions';
import TrafficRaiseCard from '../../components/Metrics/TrafficRaiseCard';
import QueriesCard from '../../components/Metrics/QueriesCard';
import UsdCard from '../../components/Metrics/UsdCard';
import EurCard from '../../components/Metrics/EurCard';
import SuccessCard from '../../components/Metrics/SuccessCard';
import FailedCard from '../../components/Metrics/FailedCard';

const Dashboard = () => {

  return (
    <Auxiliary>
      <Row>
        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
          <TrafficRaiseCard />
        </Col>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <UsdCard />
        </Col>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <EurCard />
        </Col>
        <Col xl={12} lg={12} md={12} sm={12} xs={24}>
          <QueriesCard />
        </Col>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <SuccessCard />
        </Col>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <FailedCard />
        </Col>
      </Row>
      <Row>
        <Col xl={24} lg={24} md={24} sm={24} xs={24} style={{ top: 10 }}>
          <PendingTransactions />
        </Col>
      </Row>
    </Auxiliary>
  );
};

export default Dashboard;
